<div class="email-tooltip-content">
  <div class="email-text">{{email}}</div>
</div>
